module.exports = "/_next/static/images/takeAwayJoinUs-2cf6bf07b6fd7e875621836f69095619.svg";